import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CarrierItemFragment = (
  { readonly __typename?: 'Carrier' }
  & Pick<TP.Carrier, 'id' | 'name' | 'code' | 'scacNumber' | 'currencyId'>
  & { readonly mainAddress?: TP.Maybe<(
    { readonly __typename?: 'Address' }
    & Pick<TP.Address, 'city' | 'state'>
  )> }
);

export type CarriersForCarrierPickerQueryVariables = TP.Exact<{
  filter?: TP.InputMaybe<TP.CarriersFilter>;
  first?: TP.InputMaybe<TP.Scalars['Int']>;
  last?: TP.InputMaybe<TP.Scalars['Int']>;
  after?: TP.InputMaybe<TP.Scalars['String']>;
  before?: TP.InputMaybe<TP.Scalars['String']>;
}>;


export type CarriersForCarrierPickerQuery = (
  { readonly __typename?: 'Query' }
  & { readonly carriersNullable?: TP.Maybe<(
    { readonly __typename?: 'CarrierConnection' }
    & { readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<TP.PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), readonly edges: ReadonlyArray<(
      { readonly __typename?: 'CarrierEdge' }
      & Pick<TP.CarrierEdge, 'cursor'>
      & { readonly node: (
        { readonly __typename?: 'Carrier' }
        & Pick<TP.Carrier, 'id' | 'name' | 'code' | 'scacNumber' | 'currencyId'>
        & { readonly mainAddress?: TP.Maybe<(
          { readonly __typename?: 'Address' }
          & Pick<TP.Address, 'city' | 'state'>
        )> }
      ) }
    )> }
  )> }
);

export const CarrierItemFragmentDoc = gql`
    fragment CarrierItem on Carrier {
  id
  name
  code
  mainAddress {
    city
    state
  }
  scacNumber
  currencyId
}
    `;
export const CarriersForCarrierPickerDocument = gql`
    query carriersForCarrierPicker($filter: CarriersFilter, $first: Int, $last: Int, $after: String, $before: String) {
  carriersNullable(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...CarrierItem
      }
    }
  }
}
    ${CarrierItemFragmentDoc}`;

/**
 * __useCarriersForCarrierPickerQuery__
 *
 * To run a query within a React component, call `useCarriersForCarrierPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriersForCarrierPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriersForCarrierPickerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useCarriersForCarrierPickerQuery(baseOptions?: Apollo.QueryHookOptions<CarriersForCarrierPickerQuery, CarriersForCarrierPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriersForCarrierPickerQuery, CarriersForCarrierPickerQueryVariables>(CarriersForCarrierPickerDocument, options);
      }
export function useCarriersForCarrierPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriersForCarrierPickerQuery, CarriersForCarrierPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriersForCarrierPickerQuery, CarriersForCarrierPickerQueryVariables>(CarriersForCarrierPickerDocument, options);
        }
export type CarriersForCarrierPickerQueryHookResult = ReturnType<typeof useCarriersForCarrierPickerQuery>;
export type CarriersForCarrierPickerLazyQueryHookResult = ReturnType<typeof useCarriersForCarrierPickerLazyQuery>;
export type CarriersForCarrierPickerQueryResult = Apollo.QueryResult<CarriersForCarrierPickerQuery, CarriersForCarrierPickerQueryVariables>;